import { createRoadFlow } from './road-flow'
import { createRoadProbe } from './road-probe'
import { createDivinityProbe } from './divinity-probe'
import { createHuntProbe } from './hunt-probe'
import { createGameplayProbe } from './gameplay-probe'

export function createGameplayAdapter(getFrame) {
  const documents = new WeakMap(), road = createRoadProbe(createRoadFlow()), divinity = createDivinityProbe()
  const generic = createGameplayProbe(road, createHuntProbe(), divinity)
  let serial = 0
  function game(win, depth) {
    try {
      if (win.Laya && win.Laya.__classmap && win.Laya.__classmap['com.game.model.UserObj']) return win
      if (depth < 3) for (const frame of win.document.querySelectorAll('iframe')) { const child = game(frame.contentWindow, depth + 1); if (child) return child }
    } catch (_) { /* Cross-origin requires the game host to provide same-origin execution. */ }
    return null
  }
  function panelOpen(panel, stage) {
    if (!panel || panel.destroyed) return false
    if (typeof panel.isOpen === 'boolean') return panel.isOpen
    for (let node = panel, depth = 0; node && depth < 30; depth++, node = node.parent) {
      if (node.visible === false || node.alpha === 0 || node.destroyed) return false
      if (node === stage) return true
    }
    return false
  }
  function enabled(node, stage, panel) {
    if (!node || node.mouseEnabled === false || node.gray || node.disabled || !panelOpen(panel, stage)) return false
    for (let current = node, depth = 0; current && depth < 30; depth++, current = current.parent) {
      if (current === stage || current === panel) return true
      if (current.visible === false || current.alpha === 0 || current.destroyed) return false
    }
    return false
  }
  const helpers = { game, documents, panelOpen, enabled, nextSequence: () => ++serial, identity: async value => String(value) }
  return {
    begin(task) {
      if (!window.crypto || !window.crypto.subtle || !window.crypto.randomUUID) throw new Error('请使用 HTTPS 游戏入口运行玩法任务')
      if (!game(getFrame() && getFrame().contentWindow, 0)) throw new Error('当前页面未连接支持的斗罗游戏，请在游戏包或同源游戏入口使用')
      generic.begin(task)
    },
    async sample(task) { return (task === 'divinity-monsters' ? await divinity.inspect(getFrame(), helpers) : task.startsWith('road-') ? await road.inspect(getFrame(), task, helpers) : { sample: await generic.sample(getFrame(), task) }).sample },
    execute(task, command, valid) { return task === 'divinity-monsters' ? divinity.execute(getFrame(), command, valid, helpers) : task.startsWith('road-') ? road.execute(getFrame(), task, command, valid, helpers) : generic.execute(getFrame(), task, command, valid) },
    end() { generic.end() },
  }
}
